import * as React from 'react';
import { ReactUtils } from '@shared/ui-react/ReactUtils';
import { Dialog, DialogUtils } from '@shared/ui-react/Dialog';
import { makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { DateTimeSpan } from '@shared/ui-react/UtilComponents';
import { LogpointsService } from '@shared/logpoints/LogpointsService';


export const LogpointHistoryDialog = {
    openActivityHistory: (logpointId?: number) => {
        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(<>
            <Dialog onClose={DialogUtils.close} title={__('js_logpoints.activity_history')}>
                <LogpointActivityHistoryDialogComponent logpointId={logpointId}/>
            </Dialog>
        </>, targetEl);
    },

    openApprovalsHistory: (logpointId?: number) => {
        const targetEl = document.getElementById('react-portal-root');
        ReactUtils.safeRender(<>
            <Dialog onClose={DialogUtils.close} title={__('js_logpoints.approval_list')}>
                <LogpointApprovalsHistoryDialogComponent logpointId={logpointId}/>
            </Dialog>
        </>, targetEl);
    },

    close: () => {
        ReactUtils.safeUnmountComponentAtNode(document.getElementById('react-portal-root'));
    }
};


@observer
export class LogpointApprovalsHistoryDialogComponent extends React.Component<{
    logpointId?: number
}> {
    @observable approvals = null;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = async () => {
        const approvals = await LogpointsService.getApprovalHistory(this.props.logpointId);

        runInAction(() => {
            this.approvals = approvals.logpointApprovalsData;
        });
    }

    render() {
        if (!this.approvals) {
            return <div className="overlay-loading" style={{ height: 150 }}></div>
        }
        return <>
            <table className="styled-table striped" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>{__('general.date')}</th>
                        <th>{__('general.user')}</th>
                        <th>{__('js_logpoints.column_stage')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.approvals.map(i =>
                        <tr>
                            <td><DateTimeSpan timestamp={i.timestamp}/></td>
                            <td>{i.user?.name}</td>
                            <td>{i.approveId}</td>
                        </tr>
                    )}
                    {this.approvals.length === 0 && <tr>
                        <td colSpan={9} className="padded-half text-center">{__('js_logpoints.logpoint_has_no_approvals')}</td>
                    </tr>}
                </tbody>
            </table>
        </>
    }
}


@observer
export class LogpointActivityHistoryDialogComponent extends React.Component<{
    logpointId?: number
}> {

    @observable history = null;

    constructor(props: any) {
        super(props);
        makeObservable(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch = async () => {
        const history = await LogpointsService.getChangesHistory(this.props.logpointId);

        runInAction(() => {
            this.history = history.actions;
        });
    }

    render() {
        if (!this.history) {
            return <div className="overlay-loading" style={{ height: 150 }}></div>
        }
        return <>
            <table className="styled-table striped" style={{ width: '100%' }}>
                <thead>
                    <tr>
                        <th>{__('general.date')}</th>
                        <th>{__('general.user')}</th>
                        <th>{__('js_logpoints.action')}</th>
                        <th>{__('general.description')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.history.map(i =>
                        <tr>
                            <td><DateTimeSpan timestamp={i.timestamp}/></td>
                            <td>{i.username}</td>
                            <td>{i.action}</td>
                            <td>
                                {i.oldValue ? <span>from: {i.oldValue}, to: {i.newValue}</span> : null}
                            </td>
                        </tr>
                    )}
                    {this.history.length === 0 && <tr>
                        <td colSpan={9} className="padded-half text-center">{__('js_logpoints.no_activity_for_this_logpoint')}</td>
                    </tr>}
                </tbody>
            </table>
        </>
    }
}
